import React from 'react';
import { View } from 'react-native';
import FormTextInput from '../../../../components/FormTextInput'
import MainButton from '../../../../components/Buttons/MainButton';
import { MainColors } from '../../../../constants/Colors';
import Priviledges from './Priviledges';

const UserForm = (props) => {
    return (
        <View>
            <FormTextInput
                label="Email Address"
                placeholder="Enter email address"
                autoCompleteType="email"
                autoCapitalize='none'
                keyboardType="email-address"
                returnKeyType='done'
                accessibilityLabel="Enter email address"
                accessibilityHint="Type in the user email address here"
                value={props.emailValue}
                onChangeText={props.onChangeEmailText}
                editable={props.isEmailEditable}
            />

            <Priviledges
                onAdminPressed={props.onAdminPressed}
                isAdminChecked={props.isAdminChecked}
                onMemberPressed={props.onMemberPressed}
                isMemberChecked={props.isMemberChecked}
            />

            <MainButton
                style={{ marginTop: 30, backgroundColor: props.formButtonDisabled ? MainColors.lightGray : MainColors.primary }}
                text={props.formButtonText}
                accessibilityLabel={props.formButtonAccessibilityLabel}
                accessibilityHint={props.formButtonAccessibilityHint}
                disabled={props.formButtonDisabled}
                onPress={props.formButtonPressed}
            />
        </View>
    )
}

export default UserForm;